import type { CityConfig } from "../city-template/types";

export const newportNewsVaConfig: CityConfig = {
  city: "Newport News",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "newport-news-va",
  route: "/newport-news-va",
  title: "Emergency Passport Newport News, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Newport News, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Newport News, Hampton, Williamsburg, and the Virginia Peninsula. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Newport News, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from the Virginia Peninsula, Hampton, or Williamsburg? We help Newport News travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Newport%20News%20Virginia%20skyline%20with%20the%20James%20River%20Bridge%20and%20shipyard%20waterfront%2C%20industrial%20maritime%20cityscape%20with%20modern%20downtown%20buildings%2C%20the%20Hampton%20Roads%20harbor%20and%20shipbuilding%20cranes%20visible%2C%20warm%20afternoon%20light%20with%20a%20clear%20sky%2C%20professional%20photography%20showcasing%20the%20Virginia%20Peninsula%20coastal%20city%20with%20maritime%20heritage%20and%20waterfront%20views%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape%20with%20river%20and%20harbor%20backdrop&width=1800&height=700&seq=newport-news-va-hero-001&orientation=landscape",
  heroImageAlt: "Newport News Virginia skyline with James River Bridge and shipyard waterfront on the Virginia Peninsula",
  geoPosition: "37.0871;-76.4730",
  geoPlacename: "Newport News, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 175 miles north of Newport News via I-95",
  },
  nearbyCitiesZips: [
    { name: "Newport News", zips: "23601, 23602, 23603, 23605, 23606, 23607, 23608, 23609" },
    { name: "Hampton", zips: "23630, 23651, 23661, 23663, 23664, 23665, 23666, 23667, 23668, 23669, 23681" },
    { name: "Williamsburg", zips: "23185, 23186, 23187, 23188" },
    { name: "Yorktown", zips: "23690, 23691, 23692, 23693" },
    { name: "Poquoson", zips: "23662" },
    { name: "Chesapeake", zips: "23320, 23321, 23322, 23323, 23324, 23325, 23326, 23327, 23328" },
    { name: "Virginia Beach", zips: "23450, 23451, 23452, 23453, 23454, 23455, 23456, 23457, 23458, 23459, 23460, 23461, 23462, 23463, 23464, 23465, 23466, 23467, 23468, 23471, 23479" },
    { name: "Norfolk", zips: "23501, 23502, 23503, 23504, 23505, 23506, 23507, 23508, 23509, 23510, 23511, 23513, 23514, 23515, 23517, 23518, 23519, 23520, 23521, 23523, 23529, 23541, 23551" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Suffolk", zips: "23432, 23433, 23434, 23435, 23436, 23437, 23438, 23439" },
    { name: "Smithfield", zips: "23430, 23431" },
    { name: "Gloucester", zips: "23061, 23062" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Virginia Peninsula" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Virginia Peninsula Hub", desc: "Serving Newport News, Hampton, Williamsburg, Yorktown, and Gloucester" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Virginia Beach passport services", route: "/virginia-beach" },
    { name: "Norfolk VA passport services", route: "/norfolk-va" },
    { name: "Chesapeake VA passport services", route: "/chesapeake-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Newport News remotely via secure courier. We do not have a walk-in office in Newport News — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Newport News and Virginia Peninsula travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Newport News and the Virginia Peninsula including Hampton, Williamsburg, Yorktown, Poquoson, Gloucester, and the greater Hampton Roads region",
  serviceAreaIntro: "From the historic shipyard district of Newport News to the colonial streets of Williamsburg, from the Hampton University campus to the Yorktown Victory Center, from the Jamestown ferry landing to the quiet waterfront communities of Gloucester and Smithfield — Fast Passport Center serves every corner of the Virginia Peninsula. We regularly help travelers from Hampton, Yorktown, Poquoson, and Gloucester get their passports fast.",
  nearbyCitiesIntro: "We serve all Newport News neighborhoods and the Virginia Peninsula including Hampton, Williamsburg, Yorktown, Poquoson, Gloucester, Smithfield, and the greater Hampton Roads area.",
  howItWorksIntro: "Most Newport News travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in line at a distant location.",
  mistakesIntro: "Newport News travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Newport News and Virginia Peninsula travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Newport News? Here are the most common ones we hear from Virginia Peninsula travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Newport News international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Angela M.",
      location: "Newport News, VA",
      rating: 5,
      text: "I work at the shipyard and needed an emergency passport for a family cruise to the Caribbean with 5 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS on Jefferson Avenue and it was completely hassle-free. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Derrick K.",
      location: "Hampton, VA",
      rating: 5,
      text: "As a Hampton resident, I thought I had no good options for expedited passports. Fast Passport Center made it seamless. They walked me through the acceptance clerk process and had my renewal in 4 days. The convenience for Hampton Roads and Virginia Peninsula travelers is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Susan L.",
      location: "Williamsburg, VA",
      rating: 5,
      text: "First passports for my two grandkids before a family trip to London. Fast Passport Center handled the parental consent requirements perfectly and had both passports in 5 days. For Williamsburg families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Terrell J.",
      location: "Newport News, VA",
      rating: 5,
      text: "Lost my passport 48 hours before a flight to Japan for a business conference. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my career and my business trip. Newport News professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "newport-news-va-1",
      name: "Newport News Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Newport News",
      state: "VA",
      zip: "23601",
      phone: "(757) 247-3211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Newport News",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Newport News facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "newport-news-va-2",
      name: "Hampton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Hampton",
      state: "VA",
      zip: "23661",
      phone: "(757) 727-0354",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hampton, east of Newport News",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hampton and the Virginia Peninsula. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "newport-news-va-3",
      name: "Williamsburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Williamsburg",
      state: "VA",
      zip: "23185",
      phone: "(757) 229-2181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Williamsburg, northwest of Newport News",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Williamsburg and the Historic Triangle area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "newport-news-va-4",
      name: "Yorktown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Yorktown",
      state: "VA",
      zip: "23690",
      phone: "(757) 898-3834",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Yorktown, northwest of Newport News",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Yorktown and the York County area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "newport-news-va-5",
      name: "Virginia Beach Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Virginia Beach",
      state: "VA",
      zip: "23451",
      phone: "(757) 428-0053",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Virginia Beach — southeastern Hampton Roads",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves the greater Hampton Roads region. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "newport-news-va-6",
      name: "Christopher Newport University",
      type: "Campus Resource",
      address: "1 Avenue of the Arts",
      city: "Newport News",
      state: "VA",
      zip: "23606",
      phone: "(757) 594-7000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Newport News, Christopher Newport area",
      website: "https://cnu.edu",
      websiteLabel: "CNU Official Website",
      notes: "Not a passport acceptance facility, but helpful for students. Check with student services for travel document guidance.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3+ hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Newport News photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Virginia Peninsula acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Newport News applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Newport News families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Newport News travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Newport News or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Newport News address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Newport News before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Newport News for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Virginia Peninsula." },
    { q: "How fast can I renew my passport in Newport News?", a: "Fast Passport Center offers fast passport renewal in Newport News in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Newport News?", a: "The nearest regional passport agency to Newport News is the Washington Passport Agency, located approximately 175 miles north in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Newport News." },
    { q: "Can I get a same-day passport appointment near Newport News?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Newport News residents." },
    { q: "Can I expedite a child passport in Newport News?", a: "Yes. Fast Passport Center expedites child passports in Newport News for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Newport News and Hampton Roads families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Newport News with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Newport News?", a: "With Fast Passport Center's emergency courier service, Newport News travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Newport News?", a: "Popular options include the Newport News Main Post Office (23601), Hampton Post Office (23661), Williamsburg Post Office (23185), and Yorktown Post Office (23690). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Hampton or Williamsburg?", a: "We serve the entire Virginia Peninsula and Hampton Roads region including Hampton, Williamsburg, Yorktown, Poquoson, Gloucester, Smithfield, and Suffolk. Our overnight shipping labels work from any UPS location." },
    { q: "How much does expedited passport service cost in Newport News?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Newport News", address: "700 J. Clyde Morris Blvd, Newport News, VA 23601", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Newport News", address: "1010 Jefferson Ave, Newport News, VA 23601", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Newport News", address: "12332 Warwick Blvd, Newport News, VA 23606", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Hampton", address: "2216 W Mercury Blvd, Hampton, VA 23666", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Williamsburg", address: "4900 Monticello Ave, Williamsburg, VA 23188", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Yorktown", address: "1014 Waller Mill Rd, Yorktown, VA 23690", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Newport News",
      address: "12750 Jefferson Ave, Newport News, VA 23606",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Hampton",
      address: "8109 W Mercury Blvd, Hampton, VA 23666",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Williamsburg",
      address: "7500 Richmond Rd, Williamsburg, VA 23188",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Williamsburg and the Historic Triangle. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PHF",
      name: "Newport News/Williamsburg International Airport",
      distance: "Located within Newport News city limits",
      address: "900 Bland Blvd, Newport News, VA 23602",
      note: "The closest airport to Newport News. Domestic flights to major hubs. Accessible via I-64.",
      flightUrl: "https://www.flyphf.com/",
      flightLabel: "PHF Airport",
      featured: true,
    },
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "Approximately 30 miles southeast of Newport News",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "Major regional hub for southeastern Virginia. Accessible via I-64.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: false,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Approximately 55 miles northwest of Newport News",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "Regional hub for Central Virginia. Accessible via I-64 W.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "Approximately 175 miles north of Newport News",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for the DC region. Accessible via I-64 W and I-95 N.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates", desc: "Virginia Department of Health Division of Vital Records in Richmond — order certified birth and death certificates for Newport News and Virginia Peninsula residents online, by mail, or in person.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-heart-line", label: "Marriage Records", desc: "Newport News Circuit Court Clerk — certified marriage licenses for name change passport applications and legal documentation.", url: "https://www.nngov.com/" },
    { icon: "ri-scales-line", label: "Divorce Decrees", desc: "Newport News Circuit Court — certified divorce decrees supporting passport name change or correction.", url: "https://www.vacourts.gov/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Virginia, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};